export const Containers = {
    NONE: 'none',
    REGULAR: 'regular',
};
Object.freeze(Containers);

export const CONTAINER_OPTIONS = [
    { label: 'None', value: Containers.NONE },
    { label: 'Regular', value: Containers.REGULAR },
];

export const CONTAINER_PREF = 'container';



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/common/containers.js